module.exports = __webpack_public_path__ + "static/img/e1.4252ea18.png";